<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router/dist/vue-router'
import { storeToRefs } from 'pinia'

import { useProjectStore } from '@/stores/project'
import { useCalculationStore } from '@/stores/calculation'

const route = useRoute()

const { currentItem: currentProject } = storeToRefs(useProjectStore())
const { currentItem: currentCalculation } = storeToRefs(useCalculationStore())

const currentRouteName = computed(() => route.name)
</script>

<template>
  <v-breadcrumbs-item>
    <router-link
      class="text-white toolbar-text text-decoration-none"
      :to="{ name: 'project-index' }"
    >
      Projects
    </router-link>
  </v-breadcrumbs-item>

  <template v-if="currentRouteName !== 'project-index' && currentProject.id">
    <v-breadcrumbs-divider />
    <v-breadcrumbs-item>
      <router-link
        class="text-white toolbar-text text-decoration-none"
        :to="{ name: 'calculation-index', id: currentProject.id }"
      >
        {{ currentProject.name }}
      </router-link>
    </v-breadcrumbs-item>

    <template v-if="currentCalculation.id && currentRouteName !== 'calculation-index'">
      <v-breadcrumbs-divider />
      <v-breadcrumbs class="text-white toolbar-text">
        {{ currentCalculation.name }}
      </v-breadcrumbs>
    </template>
  </template>
</template>
